<template>
  <a-card :bordered="false" :bodyStyle="{ textAlign: 'center', minHeight: '400px' }">
    <a-spin :spinning="spinning" tip="正在激活设备，请稍候..." size="large" style="margin-top: 20vh;"/>
    <success v-if="success===1 && !scan" :available="available" :total="total"/>
    <failure v-if="success===2 && !scan" :description="error" @onScan="onScan"/>
    <qrcode-stream v-if="scan" @decode="onDecode" @init="onInit"/>
    <p class="error">{{ qrcodeError }}</p>
  </a-card>
</template>

<script>
import Success from './page/Success'
import Failure from './page/Failure'
import { registerDevice } from '@/api/device'
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  name: 'Register',

  components: { Success, Failure, QrcodeStream },

  inject: ['reload'],

  data () {
    return {
      spinning: true,
      crypto: null,
      md5: null,
      success: 0,
      available: 0,
      total: 0,
      scan: false,
      qrcodeError: '',
      error: '您已成功激活这台终端，请不要断开该终端的网络连接，其界面将在若干秒后刷新。'
    }
  },

  mounted () {
    if (this.$route.query.crypto && this.$route.query.md5) {
      this.crypto = this.$route.query.crypto
      this.md5 = this.$route.query.md5
      this.register()
    } else {
      this.showResult(2, '无法识别的二维码，如有问题请联系售后人员协助解决。')
    }
  },

  methods: {
    register () {
      const form = { crypto: this.crypto, md5: this.md5 }
      registerDevice(form).then(response => {
        this.available = response.data.availableLicenses
        this.total = response.data.totalLicenses
        this.showResult(1)
      }).catch(err => {
        console.log(err)
        this.showResult(2, err)
      }).finally(() => {
      })
    },

    showResult (result, err) {
      if (err) {
        if (typeof (err) === 'string') {
          this.error = err
        } else {
          if (err.hasOwnProperty('data')) {
            this.error = err.data.data
          } else {
            this.error = '激活过程中出现未知错误, 请稍候重试！'
          }
        }
      }
      setTimeout(() => {
        this.spinning = false
      }, 800)
      setTimeout(() => {
        this.success = result
      }, 1500)
    },

    onScan () {
      this.scan = true
    },

    onDecode (decodedString) {
      console.log('二维码地址', decodedString)
      const url = window.location.href.substring(0, window.location.href.lastIndexOf('/'))
      console.log('当前页面地址', url)
      if (!decodedString.startsWith(url)) {
        this.$notification.error({
          message: '二维码地址不正确',
          description: 'Qrcode is not valid, please try again.'
        })
      } else {
        // this.$router.push({ path: decodedString })
        window.location.href = decodedString
      }
      this.scan = false
    },

    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.qrcodeError = 'ERROR: you need to grant camera access permisson'
        } else if (error.name === 'NotFoundError') {
          this.qrcodeError = 'ERROR: no camera on this device'
        } else if (error.name === 'NotSupportedError') {
          this.qrcodeError = 'ERROR: secure context required (HTTPS, localhost)'
        } else if (error.name === 'NotReadableError') {
          this.qrcodeError = 'ERROR: is the camera already in use?'
        } else if (error.name === 'OverconstrainedError') {
          this.qrcodeError = 'ERROR: installed cameras are not suitable'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.qrcodeError = 'ERROR: Stream API is not supported in this browser'
        } else {
          this.qrcodeError = '您的浏览器可能不支持该功能，请使用其他方式扫描二维码'
        }
        this.$notification.error({
          message: '无法唤起手机摄像功能',
          description: this.qrcodeError
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
